import * as React from 'react';
import { observer } from 'mobx-react';

import * as monaco from 'monaco-editor';
import MonacoEditor, { MonacoEditorProps } from 'react-monaco-editor';
import '@greycat/lang-monaco';

export interface GreyCatEditorProps extends MonacoEditorProps {
  value: string;
  className?: any;
  onChange?: (newValue: string, e: monaco.editor.IModelContentChangedEvent) => void;
}

@observer
export default class GreyCatEditor extends React.Component<GreyCatEditorProps> {

  private static LINE_HEIGHT = 18;
  private static CONTAINER_GUTTER = 10;

  constructor(props: GreyCatEditorProps) {
    super(props);
    this.onDidMount = this.onDidMount.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onDidMount(editor: monaco.editor.IStandaloneCodeEditor) {
    const el = editor.getDomNode();
    const codeContainer = el.getElementsByClassName('view-lines')[0] as HTMLElement;

    let prevLineCount = 0;

    const updateLayout = () => {
      // wait until dom rendered
      setTimeout(() => {
        const height =
          codeContainer.childElementCount > prevLineCount
            ? codeContainer.offsetHeight // unfold
            : codeContainer.childElementCount * GreyCatEditor.LINE_HEIGHT + GreyCatEditor.CONTAINER_GUTTER; // fold
        prevLineCount = codeContainer.childElementCount;

        el.style.height = height + 'px';
        el.parentElement!.style.height = 'auto';

        editor.layout();
      }, 0);
    };

    editor.onDidChangeModelDecorations(updateLayout);
    updateLayout();
  }

  onChange(newValue: string, e: monaco.editor.IModelContentChangedEvent) {
    if (this.props.onChange) {
      this.props.onChange(newValue, e);
    }
  }

  render() {
    let { value, className } = this.props;

    return (
      <MonacoEditor
        theme="vs-dark"
        options={{
          language: 'greycat',
          minimap: { enabled: false },
          scrollBeyondLastLine: false,
          folding: true,
          extraEditorClassName: className,
        }}
        value={value}
        editorDidMount={this.onDidMount}
        onChange={this.onChange}
      />
    );
  }
}
